import { STATIC_CHANNELS } from "./channels_static.js";
import { DYNAMIC_CHANNELS } from "./channels_dynamic.js";

export const CHANNELS = [
  ...[...STATIC_CHANNELS.entries()].flatMap(([id, info]) => [
    { id, name: info.name, type: "free", kind: "static" },
    ...(info.hasOverlay
      ? [
          {
            id: id + 2_000_000,
            name: info.name,
            type: "free",
            kind: "overlay",
          },
        ]
      : []),
    ...(info.hasBanner
      ? [
          {
            id: id + 3_000_000,
            name: info.name,
            type: "free",
            kind: "banner",
          },
        ]
      : []),
  ]),
  ...[...DYNAMIC_CHANNELS.entries()].map(([name, info]) => ({
    id: info.id,
    name,
    type: info.type,
    kind: "dynamic",
  })),
];
